import { useI18n } from '@/lib/i18n';

export default function DeliveryTime({ minutes }: { minutes: number }): string {
  const { t } = useI18n();
  const hours = Math.floor(minutes / 60);

  if (minutes <= 60) {
    return t('layout.:minutes minutes', { minutes });
  }

  if (hours === 1) {
    return t('layout.1 hour');
  } else if (hours < 24) {
    return t('layout.:hours hours', { hours });
  }

  return t('layout.one day');
}
